// DS: i7.21
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const FullView: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        <path
          fill="currentColor"
          d="M4.889 4A.889.889 0 004 4.889v3.555a.889.889 0 001.778 0V5.778H8A.889.889 0 008 4H4.889zM19.111 4c.491 0 .889.398.889.889v3.555a.889.889 0 01-1.778 0V5.778H16A.889.889 0 0116 4h3.111zM19.74 19.74a.889.889 0 01-.629.26H16a.889.889 0 010-1.778h2.222v-2.666a.889.889 0 111.778 0v3.555a.889.889 0 01-.26.629zM8 18.222H5.778v-2.666a.889.889 0 10-1.778 0v3.555c0 .491.398.889.889.889H8a.889.889 0 000-1.778z"
        ></path>
      </svg>
    </IconWrap>
  );
};
FullView.displayName = 'FullView';

export default FullView;
